import { useContext } from "react";
import BaseActions, { APIRequestGenerator } from "base/BaseActions";
import APIHelper from "base/APIHelper";
import BaseModel from "base/BaseModel";
import UserModel from "./userModel";

const module = "registrationQR";

const useRegistrationQrModel = () => {
  const { token, Organization } = useContext(UserModel.Context);

  const { getList, createOne, updateOne } = BaseActions(module, {
    token,
    Organization,
  });

  async function generateQRCodeString(id, body) {
    const { url, headers } = APIRequestGenerator(
      `${process.env.REACT_APP_HOST}/${module}/${id}/generateQRCodeString`,
      null,
      token,
    );
    try {
      const { data = {} } = await APIHelper(
        "PUT",
        url.toString(),
        body,
        true,
        headers,
      );
      const { url: qrCodeString = "" } = data || {};

      return Promise.resolve(qrCodeString);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return {
    getList,
    createOne,
    updateOne,
    generateQRCodeString,
  };
};

const RegistrationQrModel = BaseModel(
  useRegistrationQrModel,
  "RegistrationQrModel",
);

export { useRegistrationQrModel };
export default RegistrationQrModel;
